// extracted by mini-css-extract-plugin
module.exports = {"desc":"defaultModal_desc__2GrQM","actions":"defaultModal_actions__2xQ17"};